/* eslint-disable no-param-reassign */
import type { StandardChartLayerSpec } from '../../../../core/layer';
import type { Spec as GaugeLayerSpec } from '../../../../layer/preset/gauge/gauge';
import * as utils from '../../../../util';
import {
  BaseSpec,
  ILayerTypeSpec,
  createDataTypeValidator,
  createEncodingValidator,
  createLayerProcessor
} from '../baseProcessor';
import type { Data } from '../../specProcessor';

export type Spec = BaseSpec;

type GaugeLayerType = StandardChartLayerSpec & GaugeLayerSpec & ILayerTypeSpec;

// 创建仪表盘数据类型验证器
const validateGaugeDataTypes = createDataTypeValidator('gauge', [{ field: 'x', type: 'number' }]);

// 创建仪表盘编码验证器
const validateGaugeEncoding = createEncodingValidator([{ field: 'x' }]);

// 额外的检查函数
const additionalGaugeChecks = (layer: GaugeLayerType, data: Data) => {
  // 检查数据量是否符合要求
  const dataIndex = layer.dataIndex || 0;
  const values = data[dataIndex]?.values || [];
  if (values.length <= 1) {
    utils.logger.warn(
      'warning',
      `The "${layer.type}" layer requires more than 1 data point, but got ${values.length}`
    );
  }
};

// 创建并导出仪表盘处理器
export const gauge = createLayerProcessor<GaugeLayerType>(
  'gauge',
  validateGaugeEncoding,
  validateGaugeDataTypes,
  additionalGaugeChecks
);
